import jointScreeningDetails from "./details";

export default {jointScreeningDetails};
